<template>
  <div>
    <ul>
      <li v-if="has3d === true || (hasExterior === true && !phoneCallStatus)" class="overall-priceAd-fun-item"
        @click.stop="clickDetailLookCar" @touchend="clickDetailLookCar">
        <em class="overall-priceAd-out"></em>
        <span>
          {{ has3d? "3D看车": "360看车" }}
        </span>
      </li>
      <li @click.stop="clickDetailHasNeiShi" @touchend="clickDetailHasNeiShi" v-if="hasInterior === true"
        class="overall-priceAd-fun-item">
        <em class="overall-priceAd-in"></em>
        <span>内饰</span>
      </li>
      <li @click.stop="clickDetailPic" @touchend="clickDetailPic" class="overall-priceAd-fun-item">
        <em class="overall-priceAd-pic"></em>
        <span>图片</span>
      </li>
      <li @click.stop="clickDetailConfig" @touchend="clickDetailConfig" class="overall-priceAd-fun-item">
        <em class="overall-priceAd-setting"></em>
        <span>配置</span>
      </li>
    </ul>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import store from '@/store/index';
import layerManager from '../../../layer.manager';
import pvtrack from '@/services/pvtrack.service';
export default {
  name: 'InitDatail',
  props: {
    visible: { type: Boolean, default: false },
    seriesId: { type: Number, default: 0 },
    specId: { type: Number, default: 0 },
    has3d: { type: Boolean, default: false },
    sceneName: { type: String, default: '' }
  },
  computed: {
    ...mapGetters({
      phoneCallStatus: 'phoneCall/phoneCallStatus',
      vrSalesInfo: 'sales/vrSalesInfo',
      isSHowSmartGuide:'isSHowSmartGuide',
    }),
    channelId () {
      return this.vrSalesInfo.channelId;
    },
  },
  data () {
    return {
      hasExterior: false,
      hasInterior: false,
      interiorUrl: '',
      cls: '',
      interiorSpecId: this.specId,
    };
  },
  methods: {
    initCarVrInfo (seriesResult) {
      if (seriesResult) {
        if (seriesResult.HasExterior && seriesResult.ExtInfo.length > 0) {
          this.hasExterior = true;
        }
        if (seriesResult.HasInterior && seriesResult.IntInfo.length > 0) {
          let result = seriesResult.IntInfo.find(ele => ele.SpecId === this.specId);
          if (!result) {
            result = seriesResult.IntInfo[0];
            this.interiorSpecId = result.SpecId;
          }
          this.interiorUrl = result.ShowUrl + '?clean=1&_iframe=1&noswitch=1';
          this.hasInterior = true;
        }
      }
    },
    clickDetailLookCar (event) {
      pvtrack.pvTrackLogger({ action: 'arhall_vrkanche_click', basic: { type: 'click' }, extend: { seriesId: this.seriesId, specId: this.specId, channelId: this.channelId } });
      if (this.isSHowSmartGuide) {
        return;
      }
      layerManager.openLookCar({ seriesid: this.seriesId, specid: this.specId, is3d: this.has3d, sceneName: this.sceneName });
      event.preventDefault();
    },
    clickDetailHasNeiShi (event) {
      pvtrack.pvTrackLogger({ action: 'arhall_vrneishi_click', basic: { type: 'click' }, extend: { seriesId: this.seriesId, specId: this.specId, channelId: this.channelId } });
      if (this.isSHowSmartGuide) {
        return;
      }
      layerManager.openInterior({ specid: this.interiorSpecId, seriesid: this.seriesId, url: this.interiorUrl });
      event.preventDefault();
    },
    clickDetailPic (event) {
      pvtrack.pvTrackLogger({ action: 'arhall_moretupian_click', basic: { type: 'click' }, extend: { seriesId: this.seriesId, specId: this.specId, channelId: this.channelId } });
      if (this.isSHowSmartGuide) {
        return;
      }
      layerManager.openImages({ seriesid: this.seriesId, specid: this.specId, displayTypeId: 0 });
      event.preventDefault();
    },
    clickDetailConfig (event) {
      pvtrack.pvTrackLogger({ action: 'arhall_morejieshao_click', basic: { type: 'click' }, extend: { seriesId: this.seriesId, specId: this.specId, channelId: this.channelId } });
      if (this.isSHowSmartGuide) {
        return;
      }
      layerManager.openConfig({ type: 0, seriesid: this.seriesId, specid: this.specId });
      event.preventDefault();
    }
  },
  watch: {
    visible: {
      async handler (newVal) {
        if (newVal) {
          const seriesResult = await store.dispatch('scene/getCarVrInfoBySeriesId', {
            seriesId: this.seriesId
          });
          this.initCarVrInfo(seriesResult);
        }
      },
      immediate: true
    }
  }
};
</script>
